<template>
  <div class="kanban-board" data-component="Kanban/KanbanBoard">
    <div class="kanban-board__scroll-container">
      <div class="kanban-board__columns">
        <KanbanColumn
          v-for="column in columns"
          :key="column.id"
          :column="column"
          @card-click="$emit('card-click', $event)"
        />
      </div>
    </div>

    <!-- Scroll hint (visible only on small screens) -->
    <div class="kanban-board__scroll-hint" aria-hidden="true">
      <i class="fas fa-chevron-right"></i>
      <span>Faire défiler horizontalement</span>
      <i class="fas fa-chevron-right"></i>
    </div>
  </div>
</template>

<script>
import KanbanColumn from './KanbanColumn.vue'

export default {
  name: 'KanbanBoard',
  components: { KanbanColumn },
  props: {
    columns: {
      type: Array,
      required: true
      // Array of column objects: { id, label, color, colorLight, icon, cards[] }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './KanbanBoard.scss';
</style>
